import { selectRosterDisplayName } from "selectors/Roster";
import { FlexRow } from "styles/layout";
import {
  MatchScoreCell,
  OrgLogoContainer,
  OrgNameCell,
  SetPartScoreCell,
  TrackPartScoreCell,
} from "./styles";
import { PartScore } from "model/Match/MatchScore";
import { RosterOrgLogo } from "components/Logo/RosterOrgLogo";
import { useAppSelector } from "app/hooks";

interface Props {
  rosterId: string;
  tournamentId: string;
  scoreString: string | undefined;
  partScores: PartScore[] | undefined;
  isWinner: boolean | undefined;
}

export const MatchesViewerListTeam = ({
  rosterId,
  tournamentId,
  scoreString,
  partScores,
  isWinner,
}: Props) => {
  const displayName = useAppSelector((state) =>
    selectRosterDisplayName(state, rosterId, tournamentId)
  );

  return (
    <tr>
      <OrgNameCell isWinner={isWinner}>
        <FlexRow>
          <OrgLogoContainer>
            <RosterOrgLogo rosterId={rosterId} tournamentId={tournamentId} />
          </OrgLogoContainer>
          <span>{displayName ?? "???"}</span>
        </FlexRow>
      </OrgNameCell>
      <MatchScoreCell isWinner={isWinner}>{scoreString ?? "-"}</MatchScoreCell>
      {partScores?.map((s) =>
        s.type === "Set" ? (
          <SetPartScoreCell isWinner={s.winner ?? false}>
            {s.score}
          </SetPartScoreCell>
        ) : (
          <TrackPartScoreCell isWinner={s.winner ?? false}>
            {s.score}
          </TrackPartScoreCell>
        )
      )}
    </tr>
  );
};
